var map = {
	"./failure/KeyboardQuaggan.png": 6961,
	"./failure/QuagAlarm.png": 3989,
	"./failure/QuagAwks.webp": 5172,
	"./failure/QuagConfused.png": 5169,
	"./failure/QuagCry.png": 2306,
	"./failure/QuagDead.png": 2926,
	"./failure/QuagDead.webp": 5660,
	"./failure/QuagFIIIIRE.gif": 7112,
	"./failure/QuagFace.webp": 4143,
	"./failure/QuagFacepalm.png": 3495,
	"./failure/QuagFaint.png": 9888,
	"./failure/QuagMad.png": 4140,
	"./failure/QuagMindblown.png": 496,
	"./failure/QuagREEE.png": 8377,
	"./failure/QuagSad.png": 3654,
	"./failure/QuagSendHelp.webp": 2695,
	"./failure/QuagSherlock.png": 5953,
	"./failure/QuagShrug.png": 47,
	"./failure/QuagShrug.webp": 3313,
	"./failure/QuagSick.png": 6470,
	"./failure/QuagStress.webp": 1102,
	"./failure/QuagStunned.png": 1431,
	"./failure/QuagTableFlip.png": 7159,
	"./failure/QuagWeep.png": 1567,
	"./failure/QuagWhistle.webp": 2524,
	"./failure/QuagoOops.png": 6452,
	"./failure/SadBlueQuaggan.png": 1730,
	"./other/BackpackBlack.png": 9183,
	"./other/BackpackBlue.png": 6652,
	"./other/BackpackPink.png": 9964,
	"./other/BackpackPurple.png": 9366,
	"./other/BlackQuaggan.png": 6217,
	"./other/BlueQuaggan.png": 4388,
	"./other/Dancing Blue Quaggan.png": 2378,
	"./other/Dancing Pink Quaggan.png": 3478,
	"./other/FrenchQuaggan.png": 960,
	"./other/Goin' Fishin'.png": 4340,
	"./other/HappyBlueQuaggan.png": 3300,
	"./other/QuagBoo.png": 1290,
	"./other/QuagBootie.gif": 2705,
	"./other/QuagBootie.png": 4546,
	"./other/QuagChoyaKiller.png": 837,
	"./other/QuagDrool.png": 3966,
	"./other/QuagDrunk.png": 1828,
	"./other/QuagFishSlap.png": 4276,
	"./other/QuagFullBelly.png": 8695,
	"./other/QuagGamble.png": 320,
	"./other/QuagLOL.png": 6331,
	"./other/QuagLewd.png": 3872,
	"./other/QuagManly.png": 1531,
	"./other/QuagMmander.png": 1998,
	"./other/QuagNoU.png": 7316,
	"./other/QuagNom.png": 5916,
	"./other/QuagOld.png": 3929,
	"./other/QuagPanties.png": 5218,
	"./other/QuagPolice.png": 450,
	"./other/QuagPumpkin.png": 974,
	"./other/QuagRun.png": 5093,
	"./other/QuagSLEEP.png": 1171,
	"./other/QuagSanta.png": 8401,
	"./other/QuagSanta2.png": 3799,
	"./other/QuagSnowman.png": 3969,
	"./other/QuagStab.png": 896,
	"./other/QuagTea.png": 9832,
	"./other/QuagToxic.png": 4463,
	"./other/QuagTroll.png": 4063,
	"./other/QuagViking.png": 7302,
	"./other/QuagWaggle.gif": 9608,
	"./other/QuagWelfarePlz.png": 9854,
	"./other/Quagganception.png": 876,
	"./other/Quaggans are food NOT friends.png": 4999,
	"./other/Quaggans are friends NOT food.png": 5967,
	"./success/QuagBDay.png": 4613,
	"./success/QuagBlush.png": 7147,
	"./success/QuagCheers.png": 8115,
	"./success/QuagClap.png": 4175,
	"./success/QuagDab.png": 2744,
	"./success/QuagDaww.png": 6622,
	"./success/QuagDisco.gif": 9264,
	"./success/QuagDisco.png": 2323,
	"./success/QuagFingerguns.webp": 4231,
	"./success/QuagFlex.png": 1844,
	"./success/QuagHi.webp": 1446,
	"./success/QuagHigh5.webp": 1512,
	"./success/QuagLove.png": 5293,
	"./success/QuagMeow.png": 7193,
	"./success/QuagNoice.png": 7047,
	"./success/QuagPog.png": 6375,
	"./success/QuagSmerk.png": 365,
	"./success/QuagThumbsUP.webp": 881,
	"./success/QuagUwU.png": 1792,
	"./success/QuagWiggle.gif": 1345,
	"./success/QuagWitch.png": 8016,
	"./success/QuagXD.png": 2201,
	"./success/QuagYAY.png": 8290,
	"./success/QuagYum.png": 5162,
	"./success/Turtle Love.png": 6025,
	"./success/quaggan_rich.png": 5714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7495;